import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import Avatar from 'components/Avatar';
import LinkBuilder from 'helpers/link-builder';

import './styles.css';

const FirmEmployeesItem = props => {
  const {
    person,
    candidateId,
    actions: {
      onClickConnectHandler,
      onClickAcceptHandler,
      onClickRejectHandler,
      onClickMessageHandler,
    },
  } = props;

  const {
    CandidateID,
    ViewProfile,
    FullName,
    PictureUrl,
    FirmName,
    FirmUrlAlias,
    FirmActive,
    UGSchoolName,
    Status,
  } = person;

  const onClickAccept = () => {
    onClickAcceptHandler(person, 'Message');
  };

  const onClickReject = () => {
    onClickRejectHandler(person, 'Connect');
  };

  const onClickConnect = () => {
    onClickConnectHandler(person, 'Pending');
  };

  const onClickMessage = () => {
    onClickMessageHandler(person);
  };

  const [profileLink, firmLink] = useMemo(
    () => [
      // link
      ViewProfile === 'Yes' && Number(candidateId) !== Number(CandidateID) ? (
        <NavLink
          to={LinkBuilder.getProfileLink(CandidateID)}
          className="firm-employees__person-name"
        >
          {FullName}
        </NavLink>
      ) : (
        <span className="firm-employees__person-name--strong">{FullName} </span>
      ),
      // firm
      FirmUrlAlias ? (
        FirmActive === 'Yes' ? (
          <NavLink
            to={LinkBuilder.getFirmLink(FirmUrlAlias)}
            className="firm-employees__person-link"
          >
            {FirmName}
          </NavLink>
        ) : (
          <span className="firm-employees__person-firm">{FirmName}</span>
        )
      ) : null,
    ],
    [ViewProfile]
  );

  const status = useMemo(() => {
    if (!Status) {
      return null;
    }

    if (Status === 'AcceptReject') {
      return (
        <>
          <span
            className="firm-employees__person-cta-accept"
            onClick={onClickAccept}
          >
            Accept
          </span>
          <span
            className="firm-employees__person-cta-reject"
            onClick={onClickReject}
          >
            Reject
          </span>
        </>
      );
    }

    if (Status === 'Pending') {
      return (
        <span className="firm-employees__person-cta-pending">Pending</span>
      );
    }

    return (
      <span
        className="firm-employees__person-cta"
        onClick={Status === 'Connect' ? onClickConnect : onClickMessage}
      >
        {Status}
      </span>
    );
  }, [Status]);

  return (
    <div className="firm-employees__person">
      <div className="firm-employees__person-visual">
        <div className="firm-employees__person-avatar">
          <Avatar size={55} name={FullName} image={PictureUrl} />
        </div>
        {status}
      </div>
      <div className="firm-employees__person-content">
        {profileLink}
        {firmLink}
        <span className="firm-employees__person-place">{UGSchoolName}</span>
      </div>
    </div>
  );
};

FirmEmployeesItem.propTypes = {
  person: PropTypes.object.isRequired,
  candidateId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actions: PropTypes.shape({
    onClickConnectHandler: PropTypes.func.isRequired,
    onClickAcceptHandler: PropTypes.func.isRequired,
    onClickRejectHandler: PropTypes.func.isRequired,
    onClickMessageHandler: PropTypes.func.isRequired,
  }).isRequired,
};

export default FirmEmployeesItem;
